import { AppState } from '@app/ngrx/app-state/app-state';
import { createSelector } from '@ngrx/store';
import { adapter } from '@app/ngrx/real-property-data/reducers';

export const getRealPropertyState = (state: AppState) => state.realPropertyData;

export const getRealPropertyCollection = adapter.getSelectors(getRealPropertyState).selectAll;

export const getRealPropertyDataLoading = createSelector(getRealPropertyState, (state) => state.loading);

export const getRealPropertyCountFilter = createSelector(getRealPropertyState, (state) => state.totalCountFilter);

export const getRealPropertyCountData = createSelector(getRealPropertyState, (state) => state.totalCountData);

export const getTopRealPropertyData = createSelector(getRealPropertyState, (state) => state.top10VideoReview);
export const getTopTealPropertyLoading = createSelector(getRealPropertyState, (state) => state.top10Loading);
export const getTopRealPropertyVisibleData = createSelector(getRealPropertyState, (state) => state.visibleTop10);

export const getHotDealsPropertyData = createSelector(getRealPropertyState, (state) => state.hotDeals);
export const getHotDealsPropertyLoading = createSelector(getRealPropertyState, (state) => state.hotLoading);
export const getHotDealsPropertyVisibleData = createSelector(getRealPropertyState, (state) => state.visibleHotDeals);

export const getTop100PropertyCollection = createSelector(getRealPropertyState, (state) => state.visibleTop100);
export const getTop100Loading = createSelector(getRealPropertyState, (state) => state.top100Loading);
export const getTop100Loaded = createSelector(getRealPropertyState, (state) => state.top100Loaded);
export const getTop100PropertyTotalCount = createSelector(getRealPropertyState, (state) => state.top100TotalCount);

